type Props = React.DetailedHTMLProps<
  React.LabelHTMLAttributes<HTMLLabelElement>,
  HTMLLabelElement
> & { label: string };

export default function Label({ children, label, ...props }: Props) {
  return (
    <label {...props}>
      <div className="mb-2 font-bold">{label}</div>
      {children}
    </label>
  );
}
